import { Property } from "./interfaces";

export const codPrestador: Property = { title: "Código de Prestador", type: "string" }